module.exports = __webpack_public_path__ + "static/banner-78e853c8808ba643911b476b1b9055db.png";